module.exports = __webpack_public_path__ + "static/media/belpepper.7263c35b.svg";